/* TerraLife — alerte de retour en stock (snippets/terralife-notify-button.liquid), depuis les
   cartes produit et la fiche d'un produit épuisé. Une seule fenêtre <dialog> pour la page ;
   le client ne donne que son email. L'inscription passe par l'API client Klaviyo (clé
   publique du site), comme le bouton Klaviyo : le flow « Retour en Stock » envoie le mail.
   Toutes les variantes épuisées du produit sont suivies. */
(() => {
  const COMPANY_ID = 'UNBUTk';
  const ENDPOINT = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${COMPANY_ID}`;
  let dialog;

  const build = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'tl-notify';
    dialog.innerHTML = `
      <form method="dialog" class="tl-notify__box" novalidate>
        <button type="button" class="tl-notify__close" data-close aria-label="Fermer">×</button>
        <p class="tl-notify__eyebrow">Alerte retour en stock</p>
        <p class="tl-notify__title" data-title></p>
        <p class="tl-notify__eta" data-eta hidden></p>
        <label class="tl-notify__field">
          <span>Ton email</span>
          <input type="email" data-email required autocomplete="email" placeholder="prenom@exemple.fr">
        </label>
        <button type="submit" class="btn btn-primary w-full" data-submit>M'avertir du retour</button>
        <p class="tl-notify__msg" data-msg role="status" hidden></p>
        <p class="tl-notify__legal">Un seul email, au retour du produit.</p>
      </form>`;
    document.body.appendChild(dialog);
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    dialog.querySelector('form').addEventListener('submit', submit);
  };

  const open = (button) => {
    if (!dialog) build();
    let variants = [];
    try { variants = JSON.parse(button.dataset.variants || '[]'); } catch (e) { variants = []; }
    dialog.dataset.variants = variants.map((v) => v.id).join(',');
    dialog.querySelector('[data-title]').textContent = button.dataset.title || '';
    const eta = dialog.querySelector('[data-eta]');
    eta.hidden = !button.dataset.eta;
    eta.textContent = button.dataset.eta ? `Retour prévu le ${button.dataset.eta}.` : '';
    const email = dialog.querySelector('[data-email]');
    if (!email.value && button.dataset.email) email.value = button.dataset.email;
    const msg = dialog.querySelector('[data-msg]');
    msg.hidden = true;
    msg.className = 'tl-notify__msg';
    dialog.querySelector('[data-submit]').disabled = false;
    dialog.showModal();
    if (!email.value) email.focus();
  };

  const subscribe = (email, variant) =>
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email } } },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variant}` } },
          },
        },
      }),
    }).then((res) => {
      if (!res.ok) throw new Error(String(res.status));
    });

  async function submit(event) {
    event.preventDefault();
    const form = event.target;
    const email = form.querySelector('[data-email]');
    const msg = form.querySelector('[data-msg]');
    const variants = (dialog.dataset.variants || '').split(',').filter(Boolean);
    const show = (text, ok) => {
      msg.textContent = text;
      msg.hidden = false;
      msg.className = 'tl-notify__msg ' + (ok ? 'is-ok' : 'is-error');
    };
    if (!email.checkValidity() || !email.value.trim()) {
      show('Indique une adresse email valide.', false);
      email.focus();
      return;
    }
    if (!variants.length) {
      show('Ce produit est de nouveau disponible : recharge la page.', false);
      return;
    }
    const button = form.querySelector('[data-submit]');
    button.disabled = true;
    try {
      for (const variant of variants) await subscribe(email.value.trim(), variant);
      show('C’est noté : tu recevras un email dès son retour.', true);
    } catch (e) {
      button.disabled = false;
      show('L’inscription n’a pas abouti. Réessaie dans un instant.', false);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tl-notify]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    open(button);
  });
})();
